import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: '/personal/repair/save',
    data: from,
    method: 'post'
  })
